// extracted by mini-css-extract-plugin
export default {"cell":"TimetableCell_cell__JuoEP","task-name-paragraph":"TimetableCell_task-name-paragraph__zVWlz"};